import { PhoneIcon, CalendarDaysIcon, StarIcon, CalculatorIcon } from '@heroicons/react/24/solid';
import { useContent } from '../../context/ContentContext';

export default function PlansCTA() {
  const { content, settings } = useContent();
  const d = content.plansCta;
  const phoneDigits = settings.phone.replace(/[^0-9]/g, '');

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-brand-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-brand-orange rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-brand-tan rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-site mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-6 sm:p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 bg-brand-orange rounded-xl flex items-center justify-center">
                <StarIcon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white">
                {d.pricingHeading}
              </h3>
            </div>
            <p className="text-white/60 leading-relaxed mb-6 text-sm sm:text-base">
              {d.pricingDescription}
            </p>
            <a
              href={settings.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-3 w-full bg-brand-orange text-white px-6 py-4 rounded-xl font-semibold hover:bg-white hover:text-brand-navy transition-all duration-300 shadow-lg shadow-brand-orange/25"
            >
              <CalendarDaysIcon className="w-5 h-5" />
              {d.pricingButtonLabel}
            </a>
          </div>

          <div className="bg-white/[0.06] border border-white/10 rounded-2xl p-6 sm:p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 bg-brand-tan rounded-xl flex items-center justify-center">
                <CalculatorIcon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white">
                {d.savingsHeading}
              </h3>
            </div>
            <p className="text-white/60 leading-relaxed mb-6 text-sm sm:text-base">
              {d.savingsDescription}
            </p>
            <a
              href={`tel:${phoneDigits}`}
              className="group inline-flex items-center justify-center gap-3 w-full border border-white/20 text-white px-6 py-4 rounded-xl font-semibold hover:border-brand-orange hover:text-brand-orange transition-all duration-300"
            >
              <PhoneIcon className="w-5 h-5" />
              {settings.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
